import { gql } from 'apollo-angular';

export var update_green_features = gql`
  mutation updateGreenFeatures($id: ID, $project_id: ID!, $green_features_flag: Boolean) {
    updateGreenFeatures(id: $id, project_id: $project_id, green_features_flag: $green_features_flag){
      id, special_needs_set_aside_description, other_reports, other_green_features, green_features_flag, green_building_certifications
    }
  }
`;

export var update_special_needs = gql`
  mutation updateSpecialNeeds($id: ID, $project_id: ID!, $special_needs_set_aside_description: String!) {
    updateSpecialNeeds(id: $id, project_id: $project_id, special_needs_set_aside_description: $special_needs_set_aside_description){
      id, special_needs_set_aside_description, other_reports, other_green_features, green_features_flag, green_building_certifications
    }
  }
`;

export var update_green_building = gql`
  mutation updateGreenBuilding($id: ID, $project_id: ID!, $green_building_certifications: String!) {
    updateGreenBuilding(id: $id, project_id: $project_id, green_building_certifications: $green_building_certifications){
      id, special_needs_set_aside_description, other_reports, other_green_features, green_features_flag, green_building_certifications
    }
  }
`;

export var update_other_green = gql`
  mutation updateOtherGreen($id: ID, $project_id: ID!, $other_green_features: String!) {
    updateOtherGreen(id: $id, project_id: $project_id, other_green_features: $other_green_features){
      id, special_needs_set_aside_description, other_reports, other_green_features, green_features_flag, green_building_certifications
    }
  }
`;

export var update_other_reports = gql`
  mutation updateOtherReports($id: ID, $project_id: ID!, $other_reports: String!) {
    updateOtherReports(id: $id, project_id: $project_id, other_reports: $other_reports){
      id, special_needs_set_aside_description, other_reports, other_green_features, green_features_flag, green_building_certifications
    }
  }
`;
